const getRandomColor = {
  getColor () {
    var letters = ['#D32F2F', '#2196F3', '#CDDC39', '#673AB7', '#FF5722', '#455A64', '#4CAF50', '#FFA000', '#9C27B0', '#536DFE', '#6f74dd', '#768fff', '#00e5ff', '#558b2f', '#39796b'];
    return letters[Math.floor(Math.random() * 15)]
  }
}
export default getRandomColor
